import { CartAddEvent } from '@theme/events';

/**
 * Handles automatic redirection to cart page when cart type is not drawer
 * This ensures that after adding an item to cart, users are redirected to the cart page
 * instead of staying on the current page when drawer functionality is disabled.
 */
class CartRedirectHandler {
  constructor() {
    this.init();
  }

  init() {
    // Listen for cart add events
    document.addEventListener(CartAddEvent.eventName, this.handleCartAdd.bind(this));
  }

  handleCartAdd(event) {
    // Check if the cart add was successful and not an error
    if (event.detail?.data?.didError) {
      return; // Don't redirect on errors
    }

    // Check if cart type is not drawer
    const cartType = this.getCartType();
    if (cartType === 'drawer') {
      return; // Don't redirect if cart type is drawer
    }

    // Check if we're already on the cart page
    if (window.location.pathname.includes('/cart')) {
      return; // Don't redirect if already on cart page
    }

    // Redirect to cart page after a short delay to allow the "added" animation to show
    setTimeout(() => {
      window.location.href = '/cart';
    }, 1000); // 1 second delay to show the "added" feedback
  }

  getCartType() {
    // Try to get cart type from theme settings
    // This assumes the cart type is available in a global variable or data attribute
    const cartTypeElement = document.querySelector('[data-cart-type]');
    if (cartTypeElement) {
      return cartTypeElement.dataset.cartType;
    }

    // Fallback: check if cart drawer component exists
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      return 'drawer';
    }

    // Default to 'page' if no drawer is found
    return 'page';
  }
}

// Initialize the cart redirect handler
new CartRedirectHandler();
